<template>
    <div class="white"
         style="border-top: 5px solid #ec3c7a!important; text-align: center; margin-top: 0px; padding: 15px;box-shadow: 0 0 10px rgba(0,0,150,.08); transition: all .4s; width: 100%; justify-content: space-between; position: sticky; top: 0; z-index: 1;">
        <!--div class="pm-smart-overview-header-region" style="margin-top: -2px; flex-grow: 0;">
            <v-icon style="transition: all .3s; margin: -1px 0 0 14px;" class="white--text">
                circle_slice_both
            </v-icon>
        </div-->
        <!--div id="plan_calculator_total_price" style="font-size: 22px; flex-grow: 1; padding-left: 16px; padding-right: 8px;min-width: 0;  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" class="roboto black--text bold--text">
            {{ $t("plan_calculator.total") }}
        </div>
        <pm-price style="flex-grow: 0; flex-shrink: 0; padding-right: 16px; font-size: 22px;" class="bold--text roboto white--text" :value="fullTotal" /-->


        <span class="bold--text overview--title roboto" style="font-size: 20px">{{ $t("plan_calculator.total") }}

                    </span>
                    <br>
                    <template v-if="discount != 0">
                        <pm-price class="roboto calculator-total-price" style="text-decoration-line: line-through; weight: 600; font-size: 16px;" :value="fullTotal" /><br/>
                        <pm-price class="roboto calculator-total-price" style="font-weight: 600; font-size: 24px;" :value="fullTotal - discount" />
                    </template>
                    <template v-else>
                        <pm-price class="roboto calculator-total-price" style="font-weight: 600; font-size: 24px;" :value="fullTotal" />
                    </template>

    </div>
</template>

<style lang="scss">
    .pm-smart-overview-header {
        position: relative;

        .pm-smart-overview-header-region {
            width: 48px;
            text-align: center;
            flex-grow: 0;
            flex-shrink: 0;
        }
    }

@media (min-width: 700px) {
    .calculator-total-price {
        font-size: 28px !important;
    }
}
</style>


<!--template>
    <div class="grey lighten-4 pm-simple-plan--overview-header">

        <div class="white" style="margin-top: 20px; padding: 15px 0 20px 0;">
            <div>
                <span class="bold--text overview--title roboto f13">{{ $t("plan_calculator.total") }}</span>
                <br>
                <pm-price class="roboto" style="font-weight: 300; font-size: 20px;" :currency="currency" :value="$store.state.simplePlan.upperJawTotal + $store.state.simplePlan.lowerJawTotal" />
                <br/>
                <v-btn @click="save" class="roboto f13 black--text bold--text" flat style="margin: 0; height: auto; border: 2px solid #ededed; padding: 4px 16px; border-radius: 24px; margin-top: 12px;"><v-icon style="margin-right: 8px;">save_outline</v-icon> Terv mentése</v-btn>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .pm-simple-plan--overview-header {
        padding: 1px 0 0 0;
        text-align: center;
        flex-grow: 0;
        margin: 0;
        font-weight: 600;
        box-shadow: 0 5px 10px rgba(0,0,0,.08);

        &.grey.lighten-3 {
            border-bottom: 1px solid #fff!important;
         }

        .overview--title {
            font-size: 14px;
        }

        .overview--sub-title {
            text-transform: uppercase; font-size: 14px;
        }
    }


</style-->

<script>
    import { calculateDiscount } from "./plan";
export default {
    data: () => {
        return ({});
    },
    methods: {
        save() {
            const data = {
                component: "plan",
                timestamp: Date.now(),
                data: JSON.stringify(this.$store.state.simplePlan),
                totalUpper: this.$store.state.simplePlan.upperJawTotal,
                totalLower: this.$store.state.simplePlan.lowerJawTotal,
                titleUpper: this.$store.state.simplePlan.upperJawTitle,
                titleLower: this.$store.state.simplePlan.lowerJawTitle,
                currency: this.$store.state.currency,
            };
            this.$store.commit("pushToHistory", data);
            // @todo: localsettings
            this.$bus.$emit("app.showSnackbar", {color: "blue", text: this.$t("plan_simple.plan_saved")});
        },
    },
    computed: {
        fullTotal() {
            // $store.state.simplePlan.upperJawTotal + $store.state.simplePlan.lowerJawTotal + $store.state.simplePlan.extraTotal
            // const extraValue = Math.round((this.$store.state.simplePlan.upperJawTotal + this.$store.state.simplePlan.lowerJawTotal) * (this.percentage / 100));
            let extraValue = 0;

            this.$store.state.simplePlan.extraSteps.forEach((step) => {
                if (step.isPercentage && step.amount > 0) {
                    extraValue = Math.round((this.$store.state.simplePlan.upperJawTotal + this.$store.state.simplePlan.lowerJawTotal) * (step.amount / 100));
                }
            });
            const fullTotal = extraValue + this.$store.state.simplePlan.upperJawTotal + this.$store.state.simplePlan.lowerJawTotal + this.$store.state.simplePlan.extraTotal;
            this.$store.state.simplePlan.fullTotal = fullTotal;
            return fullTotal;
        },
        discount() {
            return calculateDiscount();
        }
    },
};
</script>
